// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"banner-without-video_wrapper__R6BOG"};